export default __webpack_public_path__ + "static/media/trophy-border.14b4cbc0.svg";